import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { SharedLayoutComponent } from './shared/components/shared-layout/shared-layout.component';
import { IdentityLayoutComponent } from './identity/components/identity-layout/identity-layout.component';
import { SalesforceAuthComponent } from './identity/components/salesforce-auth/salesforce-auth.component';

const routes: Routes = [
  // Default route
  { path: '', redirectTo: '/identity/login', pathMatch: 'full' },

  // Salesforce SSO
  { path: 'salesforce-auth', component: SalesforceAuthComponent },

  // Identity
  {
    path: 'identity',
    component: IdentityLayoutComponent,
    loadChildren: () => import('./identity/identity.module').then(m => m.IdentityModule),
  },

  // Servicer
  {
    path: 'servicer',
    component: SharedLayoutComponent,
    loadChildren: () => import('./servicer/servicer.module').then(m => m.ServicerModule),
  },

  // Advisor
  {
    path: 'advisor',
    component: SharedLayoutComponent,
    loadChildren: () => import('./advisor/advisor.module').then(m => m.AdvisorModule),
  },

  // Wildcard fallback (must be last!)
  { path: '**', redirectTo: '/identity/login' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { enableTracing: true })],
  exports: [RouterModule],
})
export class RoutingModule { }
